/** @format */

import { AiFillAppstore } from "react-icons/ai";
import {  FaGlobe } from "react-icons/fa";
import {  SiReact } from "react-icons/si";
import { SiDotnet } from "react-icons/si";

// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <SiReact />,
    title: "Frontend Web Development",
    des: "Proficient in creating captivating user interfaces using React, HTML, CSS, and JavaScript. Specialized in frameworks like Angularjsand Next.js for building modern and responsive web applications",
  },
  {
    id: 2,
    icon: <SiDotnet />,
    title: "Backend Web Development",
    des: "Skilled in backend development with a focus on building robust APIs. Experienced in technologies such as C#, .NET, Nest.js, and Node.js. Ensures the development of fully functional and scalable web applications",
  },
  {
    id: 3,
    icon: <AiFillAppstore />,
    title: "App Development",
    des: "Crafting feature-rich applications with a focus on delivering seamless user experiences. Proficient in utilizing cutting-edge technologies and tools to build responsive and high-performance applications.",
  },
  {
    id: 4,
    icon: <FaGlobe />,
    title: "Hosting Websites",
    des: "Expertise in hosting and deploying websites for optimal performance. Familiar with various hosting platforms and deployment strategies to ensure that websites are secure, reliable, and accessible to a global audience.",
  },
];
